import { useEffect, useState } from 'react'

import { parseEventTimes, serializeEventTimes } from '@/lib/station-order-sort'

export const STATION_EVENT_TIMES_KEY = 'station.event-times'

function readStored(): Map<string, number> {
    if (typeof window === 'undefined') return new Map()
    try {
        return parseEventTimes(
            window.localStorage.getItem(STATION_EVENT_TIMES_KEY),
        )
    } catch {
        // Storage bị chặn (chế độ riêng tư, chính sách thiết bị) — chạy tiếp
        // với map rỗng, chỉ mất thứ tự của các sự kiện trước đó.
        return new Map()
    }
}

/**
 * Mốc sự kiện gần nhất theo đơn, giữ lại qua các lần tải trang.
 *
 * Máy trạm hay bị F5 hoặc khởi động lại giữa ca. Không lưu thì thứ tự theo hoạt
 * động mất sạch và bảng quay về xếp theo giờ tạo đơn — đúng hành vi lỗi mà
 * `station-order-sort` sinh ra để sửa.
 */
export function useStationEventTimes() {
    const [eventTimes, setEventTimes] =
        useState<Map<string, number>>(readStored)

    useEffect(() => {
        try {
            window.localStorage.setItem(
                STATION_EVENT_TIMES_KEY,
                serializeEventTimes(eventTimes),
            )
        } catch {
            // Hết quota hoặc bị chặn — thứ tự trong phiên hiện tại vẫn đúng.
        }
    }, [eventTimes])

    return [eventTimes, setEventTimes] as const
}
